import { Injectable, NgZone } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, NavigationStart, NavigationCancel } from '@angular/router';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { Layer } from './../models/layer';
import { App } from '@capacitor/app';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import BaseLayer from 'ol/layer/Base';
import { TraceDrawerType } from './trace.service';


//universal links on ios observer Appevent in app.component
@Injectable({ providedIn: 'root' })
export class AppEventService {
  universalLink$ = new BehaviorSubject<{ [key: string]: any }>(null);
}

@Injectable({
  providedIn: 'root'
})
export class PermalinkService {

  //private _params$ = new ReplaySubject<Params>(1)

  //test if router is naviagting already
  //private isNavigating = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    // private zone: NgZone,
  ) {
    // this.listenForDeepLinks();

    /*
    this.router.events.pipe(
      filter(event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      )
    ).subscribe(event => {
      this.isNavigating = event instanceof NavigationStart;
    });
    */

  }

  //universal links or deeplinks for ios
  //   private listenForDeepLinks() {
  //   // App.getLaunchUrl().then((result) => {
  //   //   if (result?.url) {
  //   //     this.zone.run(() => this.handleIncomingUrl(result.url));
  //   //   }
  //   // });

  //   App.addListener('appUrlOpen', ({ url }) => {
  //     this.zone.run(() => this.handleIncomingUrl(url));
  //   });
  // }
  //not used 
  handleIncomingUrl(url, params: Params) {
    // const parsedUrl = new URL(url);
    // const params = parsedUrl.searchParams;

    // const x = params.get('x');
    // const y = params.get('y');
    // const zoom = params.get('zoom');
    // const baselayer = params.get('baselayer');
    // const sublayer = params.get('sublayer');
    // const multilayer = params.get('multilayer');
    // const layers = params.get('layers');
    // const layers_opacity = params.get('layers_opacity');
    // const layers_visibility = params.get('layers_visibility');
    // const topic = params.get('topic');
    // const trace = params.get('trace');
    // const tracezoom = params.get('tracezoom');
    // const language = params.get('l');

    // this.zone.run(() => {
    //   if (x && y && zoom) this.updatePositionParams(x, y, zoom);
    //   if (baselayer && sublayer) this.updateBaseLayerGroupParam(baselayer, sublayer, multilayer === 'true');
    //   else if (baselayer) this.updateBaseLayerParam({ id: baselayer } as Layer);
    //   if (layers || layers_opacity || layers_visibility) this.updateLayersParam(layers, layers_opacity, layers_visibility);
    //   if (topic) this.updateTopicParam(topic);
    //   if (trace) this.updateTraceParam(trace);
    //   if (tracezoom) this.updateTraceZoomParam(tracezoom === 'true');
    //   if (language) this.updateLanguage(language);
    // });

    // const queryParams: { [key: string]: string } = {};
    // params.forEach((value, key) => {
    //   queryParams[key] = value;
    // });

    // this.zone.run(() => {
    //   this.router.navigate([], {
    //    // relativeTo: this.route,
    //     queryParams,
    //   //  queryParamsHandling: '', 
    //   });

    // });
    // this._params$.next(params);
    //this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    // this.router.navigate([], { queryParams: params });
    // });

  }

  updatePositionParams(x: string, y: string, zoom: string) {
    // this.zone.run(() => {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        x: x,
        y: y,
        zoom: zoom,
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
    // });
  }

  updateBaseLayerParam(layer: Layer) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { baselayer: layer.id.toLowerCase() },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateBaseLayerGroupParam(groupLayerId: string, subLayerId: string, showAllSubLayers: boolean = false) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        baselayer: groupLayerId.toLowerCase(),
        sublayer: subLayerId.toLowerCase(),
        multilayer: showAllSubLayers
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateLayersParam(layersString, opacitiesString, visibilitiesString) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        layers: layersString.length > 0 ? layersString.toString() : undefined,
        layers_opacity: opacitiesString.length > 0 ? opacitiesString.toString() : undefined,
        layers_visibility: visibilitiesString.length > 0 ? visibilitiesString.toString() : undefined
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateTopicParam(topic: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        topic: topic
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateViewModeParam(viewmode: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { viewmode: viewmode },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateSecondLayerParam(layerId: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { secondbaselayer: layerId },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
  updatePrimaryLayerParam(layerId: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { baselayer: layerId },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateBaseAndSecondLayerParam(leftLayerId: string, rightLayerId: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { baselayer: rightLayerId, secondbaselayer: leftLayerId },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  /**
   * info: if you would change the parameter name here, you also need to update traceService (url param functions) & ShareMapComponent
   * @param uniqueIdentifier
   */
  updateTraceParam(uniqueIdentifier: string) {
    //making sure param tracezoom is removed, if not yet removed
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        trace: uniqueIdentifier && uniqueIdentifier.length > 0 ? uniqueIdentifier : undefined,
        tracezoom: undefined
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
  /**
   * info: if you would change the parameter name here, you also need to update TmvComponent & ShareMapComponent
   * @param zoom if true the parameter will be added; if false it will be removed
   */
  updateTraceZoomParam(zoom: boolean) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tracezoom: zoom ? 'true' : undefined
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
  /**
  * @param tabName we don't check the correctness of the name here, it should correspond to an enum name in TraceDrawerType (not CLOSE_AND_VIEW_ROUTE), case-insensitive; if empty or undefined, the parameter will be removed
  */
  updateTraceTabParam(tabName?: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tracetab: typeof tabName === 'string' && tabName.trim().length > 0 && tabName.trim().toUpperCase() !== 'CLOSE_AND_VIEW_ROUTE' ? tabName.trim() : undefined
      },
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  updateLanguage(language: string) {
    this.router.navigate([], {
      // relativeTo: this.route,
      queryParams:
        { l: language }
      ,
      skipLocationChange: false,
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
  getParams() {
    return this.route.queryParams;
  }

  getLangParam(): string {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('l')
  }

  getEnabledLayersIdFromUrl(): string[] {
    let resultArray: string[] = new Array();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString).get('layers');
    resultArray = urlParams ? urlParams.split(",") : [];
    return resultArray;
  }

  getUrlParam(param: string): string {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param)
  }
}
